import {
  ReviewType,
  ReviewTheme,
} from '../../__generated__/chirp/com/hubspot/reviews/rpc/ReviewsRpc';
import { useGetThemesQuery } from '../../__generated__/chirp/com/hubspot/reviews/rpc/ReviewsRpc.hooks';

interface UseReviewThemesProps {
  entityId: number;
  language: string;
  reviewType: ReviewType;
  skip?: boolean;
}

export function useReviewThemes({
  entityId,
  language,
  reviewType,
  skip,
}: UseReviewThemesProps): {
  themes: ReviewTheme[] | null;
  themesUpdatedAt: number | null;
  loading: boolean;
} {
  const { data, loading, error } = useGetThemesQuery({
    variables: { entityId, language, type: reviewType },
    skip,
  });

  const themes = loading || error ? null : data?.themes ?? null;
  const themesUpdatedAt = loading || error ? null : data?.updatedAt ?? null;

  return { themes, themesUpdatedAt, loading };
}
